<style lang="stylus">
.profile-section-header {
  font-size: 24px;
  font-weight: 900 !important;
  display: flex;
  align-items: center;

  span {
    font-size: 12px !important;
    font-weight: 600 !important;
  }
}

.font-size16 {
  font-size: 16px;
}

.font-weight600 {
  font-weight: 600;
}

.font-weight400 {
  font-weight: 400;
}

.v-col {
  padding: 0 !important;
  margin: 0 !important;
}

.v-row {
  padding: 0 !important;
  margin: 0 !important;
}
</style>

<template>
  <v-card flat class="mt-4">
    <v-col cols="12" sm="12" md="11" lg="8" xl="8">
      <v-row>
        <v-col cols="12" class="profile-section-header" :class="{ headline: $vuetify.display.mdAndUp }">
          Basic Information
          <span
            v-if="!checkIncompleteBasicInfo"
            class="font-weight-black ml-1 text-body-2 px-1"
            style="background: #fec528"
            >Incomplete</span
          ></v-col
        >
        <v-col cols="12">
          <v-row>
            <v-col cols="6" class="font-size16 font-weight600 my-1">
              Email
              <v-tooltip right color="Color/Gray/dark-2">
                <template v-slot:activator="{ props }">
                  <v-icon
                    style="cursor: pointer; font-size: 13px; pointer-events: auto !important; margin-bottom: 3px"
                    v-bind="props"
                  >
                    mdi-help-circle-outline</v-icon
                  >
                </template>
                <span style="font-size: 10px; font-weight: 500; color: white; text-align: left"
                  >This email must remain unique for login and is linked to your ASURITE ID.</span
                >
              </v-tooltip>
            </v-col>
            <v-col cols="6" class="font-size16 font-weight400 my-1">{{ email || '-' }}</v-col>
            <v-col cols="6" class="font-size16 font-weight600 my-1">
              Notifications Email

              <v-tooltip right color="Color/Gray/dark-2">
                <template v-slot:activator="{ props }">
                  <v-icon
                    style="cursor: pointer; font-size: 13px; pointer-events: auto !important; margin-bottom: 3px"
                    v-bind="props"
                  >
                    mdi-help-circle-outline</v-icon
                  >
                </template>
                <span style="font-size: 10px; font-weight: 500; color: white; text-align: left"
                  >This email will receive all course notifications.</span
                >
              </v-tooltip>
            </v-col>
            <v-col cols="6" class="font-size16 font-weight400 my-1">{{ notificationsEmail || '-' }} </v-col>
            <v-col cols="6" class="font-size16 font-weight600 my-1">
              Birthday
              <v-tooltip right color="Color/Gray/dark-2">
                <template v-slot:activator="{ props }">
                  <v-icon
                    style="cursor: pointer; font-size: 13px; pointer-events: auto !important; margin-bottom: 3px"
                    v-bind="props"
                  >
                    mdi-help-circle-outline</v-icon
                  >
                </template>
                <span style="font-size: 10px; font-weight: 500; color: white; text-align: left">MM/DD/YYYY</span>
              </v-tooltip>
            </v-col>
            <v-col cols="6" class="font-size16 font-weight400">{{ birthDate || '-' }}</v-col>

            <v-col cols="6" class="font-size16 font-weight600 my-1">Address</v-col>
            <v-col cols="6" class="font-size16 font-weight400 my-1">
              <!-- accounting for the 3 spaces -->
              {{ address.length > 3 ? address : '-' }}</v-col
            >
            <v-col cols="6" class="font-size16 font-weight600 my-1">Country</v-col>
            <v-col cols="6" class="font-size16 font-weight400 my-1">{{ country || '-' }}</v-col>
            <v-col cols="6" class="font-size16 font-weight600 my-1">Phone</v-col>
            <v-col cols="6" class="font-size16 font-weight400 my-1">{{ phoneNumber || '-' }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
        <v-col
          cols="12"
          class="font-weight-black profile-section-header"
          :class="{ headline: $vuetify.display.mdAndUp }"
          v-if="collectDemographicInfo"
        >
          Demographic Information
          <span
            v-if="!checkIncompleteDemographicInfo"
            class="font-weight-black ml-1 text-body-2 px-1"
            style="background: #fec528"
            >Incomplete</span
          >
        </v-col>
        <v-col cols="12" v-if="collectDemographicInfo">
          <v-row>
            <v-col cols="6" class="font-size16 font-weight600 my-1">Gender</v-col>
            <v-col cols="6" class="font-size16 font-weight400">{{ gender || '-' }}</v-col>
            <v-col cols="6" class="font-size16 font-weight600 my-1">Pronouns</v-col>
            <v-col
              cols="6"
              class="font-size16 font-weight400"
              :class="pronoun !== 'Prefer not to say' ? 'pronounCapitalize' : ''"
              >{{ pronoun || '-' }}</v-col
            >
            <v-col cols="6" class="font-size16 font-weight600 my-1">Ethnicity</v-col>
            <v-col cols="6" class="font-size16 font-weight400">{{
              (ethnicity || '').replaceAll(';', '; ') || '-'
            }}</v-col>
            <v-col cols="6" class="font-size16 font-weight600 my-1">Income</v-col>
            <v-col cols="6" class="font-size16 font-weight400">{{ householdIncome || '-' }}</v-col>
            <v-col cols="6" class="font-size16 font-weight600 my-1">I am...</v-col>
            <v-col cols="6" class="font-size16 font-weight400">{{ learnersIntent || '-' }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="showEducationalInfo">
          <v-divider />
        </v-col>
        <v-col
          v-if="showEducationalInfo"
          cols="12"
          class="font-weight-black profile-section-header"
          :class="{ headline: $vuetify.display.mdAndUp }"
        >
          Educational Information
        </v-col>
        <v-col cols="12" v-if="showEducationalInfo">
          <v-row>
            <v-col cols="6" class="font-size16 font-weight600">High School</v-col>
            <v-col cols="6" class="font-size16 font-weight400">{{ currentHighSchool || '-' }}</v-col>
            <v-col cols="6" class="font-size16 font-weight600">School Type</v-col>
            <v-col cols="6" class="font-size16 font-weight400">{{ highSchoolType || '-' }}</v-col>
            <v-col cols="6" class="font-size16 font-weight600">Expected Graduate Date</v-col>
            <v-col cols="6" class="font-size16 font-weight400">
              {{
                highSchoolExpectedGraduationDate
                  ? `${highSchoolExpectedGraduationMonth} ${highSchoolExpectedGraduationYear}`
                  : '-'
              }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-if="showAccountLinking">
          <v-divider />
        </v-col>
        <v-col
          cols="12"
          class="font-weight-black profile-section-header"
          :class="{ headline: $vuetify.display.mdAndUp }"
          v-if="showAccountLinking"
        >
          Account Linking
        </v-col>
        <v-col cols="12" v-if="showAccountLinking">
          <v-row>
            <v-col cols="6" class="font-size16 font-weight600 d-flex align-center" style="padding: 10px 5px"
              >ASURITE ID</v-col
            >
            <v-col cols="6" class="font-size16 font-weight400 d-flex align-center">
              <span v-if="hasLinkedAsurite">{{ linkedAsurite }}</span>
              <v-btn
                v-else
                variant="outlined"
                :ripple="false"
                rounded
                @click="linkAsurite"
                :loading="linkingAsurite"
                style="
                  border: 2px solid #fec528;
                  background: #fec528 !important;
                  padding: 8px 12px;
                  min-width: auto;
                  width: auto;
                  max-width: fit-content;
                "
                color="#000000"
                class="text-none"
              >
                <v-icon small style="margin-right: 4px; margin-left: 0">mdi-link</v-icon>
                Link your ASURITE
              </v-btn>
            </v-col>
            <v-col cols="12" class="caption mt-2 text-grey" v-if="!hasLinkedAsurite">
              Link your ASURITE ID to access additional features and synchronize your account information.
            </v-col>
            <v-col cols="12" class="" v-else>
              <div class="caption text-grey">Your ASURITE ID is successfully linked to your account.</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div v-show="false">{{ detectChange }}</div>
    </v-col>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue';
import { useUserStore } from '@/stores/user';
import { useHsGradDateStore } from '@/stores/hsGradDate';

import moment from 'moment-timezone';
import { SessionInitializer } from '../mixins/sessionInitializer';
import { Helper } from '../mixins/helpers.js';
import { isFeatureEnabled } from '../../feature-flags';
export default defineComponent({
  name: 'LearnerProfileInfo',

  data() {
    return {
      email: null,
      birthDate: null,
      address: null,
      country: null,
      phoneNumber: null,
      gender: null,
      ethnicity: null,
      householdIncome: null,
      pronoun: null,
      learnersIntent: null,
      notificationsEmail: null,
      currentHighSchool: null,
      highSchoolType: null,
      highSchoolExpectedGraduationDate: null,
      highSchoolExpectedGraduationMonth: null,
      highSchoolExpectedGraduationYear: null,
      linkingAsurite: false,
      linkedAsurite: null
    };
  },

  mixins: [Helper, SessionInitializer],

  watch: {
    // A date saved in the graduation modal while this page is open.
    gateGraduationDate(value) {
      if (!value) return;
      const graduationDate = moment(`${value}-01`);
      this.highSchoolExpectedGraduationDate = `${value}-01`;
      this.highSchoolExpectedGraduationMonth = graduationDate.format('MMMM');
      this.highSchoolExpectedGraduationYear = graduationDate.format('YYYY');
    }
  },

  computed: {
    gateGraduationDate() {
      return useHsGradDateStore().graduationDate;
    },
    userStore() {
      return useUserStore();
    },
    checkIncompleteBasicInfo() {
      return (
        (this.email || '').length > 0 &&
        (this.birthDate || '').length > 0 &&
        (this.address || '').length > 0 &&
        (this.country || '').length > 0 &&
        (this.phoneNumber || '').length > 0
      );
    },
    checkIncompleteDemographicInfo() {
      return (
        (this.gender || '').length > 0 &&
        (this.pronoun || '').length > 0 &&
        (this.ethnicity || '').length > 0 &&
        (this.householdIncome || '').length > 0 &&
        (this.learnersIntent || '').length > 0
      );
    },
    detectChange() {
      if (this.shouldRefreshData) {
        this.loadData();
      }

      return this.shouldRefreshData;
    },
    showEducationalInfo() {
      const learner = this.userStore.apis.learnerData;
      return (
        Helper.methods.isAcceleratePartner(learner._partnerURLSubDomain) ||
        Boolean(useHsGradDateStore().reason) ||
        Boolean(learner._currentHighSchool || learner._highSchoolType || learner._highSchoolExpectedGraduationDate)
      );
    },
    hasLinkedAsurite() {
      return this.linkedAsurite && this.linkedAsurite.length > 0 && this.linkedAsurite !== 'null';
    },
    showAccountLinking() {
      return isFeatureEnabled('ACCOUNT_LINKING');
    }
  },

  methods: {
    loadData() {
      ({
        email: this.email,
        phoneNumber: this.phoneNumber,
        gender: this.gender,
        otherGender: this.otherGender,
        pronoun: this.pronoun,
        ethnicity: this.ethnicity,
        householdIncome: this.householdIncome,
        learnersIntent: this.learnersIntent,
        notificationsEmail: this.notificationsEmail,
        mailingAddress: { country: this.country },
        educationalInformation: this.educationalInformation,
        highSchoolExpectedGraduationDate: this.highSchoolExpectedGraduationDate
      } = this.learnerData);

      this.birthDate = this.dateFormatUS(this.learnerData.birthDate);
      const { street, city, state, postalCode } = this.learnerData.mailingAddress;
      this.address = (street || '') + ' ' + (city || '') + ' ' + (state || '') + ' ' + (postalCode || '');

      // Use fallback for high school fields if missing
      this.currentHighSchool =
        this.learnerData?.currentHighSchool || this.userStore.apis.learnerData._currentHighSchool || '';
      this.highSchoolType = this.learnerData?.highSchoolType || this.userStore.apis.learnerData._highSchoolType || '';
      this.highSchoolExpectedGraduationDate =
        this.learnerData?.highSchoolExpectedGraduationDate ||
        this.userStore.apis.learnerData._highSchoolExpectedGraduationDate ||
        '';
      if (this.highSchoolExpectedGraduationDate) {
        const graduationDate = moment(this.highSchoolExpectedGraduationDate);
        this.highSchoolExpectedGraduationMonth = graduationDate.format('MMMM');
        this.highSchoolExpectedGraduationYear = graduationDate.format('YYYY');
      } else {
        this.highSchoolExpectedGraduationMonth = '';
        this.highSchoolExpectedGraduationYear = '';
      }

      // Load ASURITE information
      const userStore = useUserStore();
      this.linkedAsurite = this.learnerData.asuRite || userStore.apis.learnerData._asuRite || null;
    },

    linkAsurite() {
      this.linkingAsurite = true;

      try {
        this.$auth.login('asurite', {
          state: btoa(
            JSON.stringify({
              redirect_to: {
                name: 'profile'
              },
              learnerId: this.userStore.apis.learnerData._learnerId
            })
          )
        });
      } catch (error) {
        this.linkingAsurite = false;
        // Error initiating ASURITE login
      }
    }
  },

  props: {
    learnerData: Object,
    collectDemographicInfo: Boolean,
    shouldRefreshData: Boolean
  },

  created() {
    this.loadData();
  }
});
</script>

<style lang="stylus" scoped>
.pronounCapitalize {
  text-transform: capitalize;
}
</style>
